import React from 'react'

import TutorialMiningContainer from './TutorialMiningContainer'

const TutorialMiningScreen = () => <TutorialMiningContainer />

export default TutorialMiningScreen
